var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 37,
    viewBox: "0 0 53 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2250_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8295 5.77097C51.5255 4.65554 50.9325 3.63863 50.1095 2.82151C49.2866 2.0044 48.2624 1.41558 47.139 1.1137C43.0261 0 26.4731 0 26.4731 0C26.4731 0 9.91932 0.033711 5.80644 1.14741C4.68298 1.44931 3.65879 2.03816 2.83584 2.85531C2.01289 3.67247 1.41991 4.68941 1.11594 5.80489C-0.128113 13.0606 -0.610702 24.1166 1.1501 31.0821C1.4541 32.1975 2.04709 33.2144 2.87004 34.0315C3.69299 34.8486 4.71717 35.4374 5.8406 35.7393C9.95348 36.853 26.5069 36.853 26.5069 36.853C26.5069 36.853 43.0601 36.853 47.1727 35.7393C48.2962 35.4375 49.3204 34.8487 50.1434 34.0316C50.9664 33.2144 51.5594 32.1975 51.8634 31.0821C53.1756 23.8161 53.5799 12.7668 51.8295 5.77097Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2046 26.3234L34.9366 18.4263L21.2046 10.5293V26.3234Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2250_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 37,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.416916b296bd6c526fea210dfc85b3e8.svg";
export { ForwardRef as ReactComponent };